module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Earnings Calculator",
      "icon": "earnings"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    on: {
      "input": _vm.reCalculateRetired
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.reCalculateRetired]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Start of Earnings"
    }
  }, [_c('date-input', {
    ref: "dateFrom",
    on: {
      "input": _vm.reCalculateEarnings
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.dateFromIsValid()
    }
  }, [_vm._v("\n                    Date is required, must be in the format DD/MM/YYYY and must be after 06/04/2008.\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "End of Earnings"
    }
  }, [_c('date-input', {
    ref: "dateTo",
    on: {
      "input": _vm.reCalculateEarnings
    },
    model: {
      value: (_vm.dateTo),
      callback: function($$v) {
        _vm.dateTo = $$v
      },
      expression: "dateTo"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.dateToIsValid()
    }
  }, [_vm._v("\n                    Date is required, must be in the format DD/MM/YYYY, and must be after both 06/04/2008 and the 'Start of Earnings'.\n                ")])], 1), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRetired),
      expression: "!isRetired"
    }],
    attrs: {
      "label": "Employment Type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentType),
      expression: "employmentType"
    }],
    ref: "employmentType",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.reCalculateEarnings]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Income"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentIncome),
      expression: "employmentIncome"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "netOrGrossFirstText",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.employmentIncome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.employmentIncome = $event.target.value
      }, _vm.reCalculateEarnings],
      "focus": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || ''
      },
      "blur": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || 0
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentIncomeNetGross),
      expression: "employmentIncomeNetGross"
    }],
    ref: "netOrGrossFirst",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentIncomeNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.reCalculateEarnings]
    }
  }, [_c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Total Gross Earnings",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.totalGrossIncome
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Total Net Earnings",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.totalNetIncome
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalNetIncome > 0),
      expression: "totalNetIncome > 0"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto p-earnings__calc"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                With annual gross earnings of " + _vm._s(_vm.currencyFormat(_vm.totalGrossIncome || 0)) + ", from " + _vm._s(_vm.dateFrom) + " to " + _vm._s(_vm.dateTo) + ",\n                " + _vm._s(_vm.currencyFormat(_vm.totalGrossIncome - _vm.totalNetIncome || 0)) + " of tax and/or NI contributions would be paid annually.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                This results in total Net earnings of " + _vm._s(_vm.currencyFormat(_vm.totalNetIncome || 0)) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "hotfix-width"
  }, [_vm._v("\n                The following chart provides a visual indication of income tax paid on employment\n                income, and any national insurance contributions applicable on employment income:\n            ")]), _vm._v(" "), (_vm.totalGrossIncome) ? _c('div', {
    staticClass: "chart"
  }, [_c('pie-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("\n                Earnings\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Between " + _vm._s(_vm.dateFrom) + " and " + _vm._s(_vm.dateTo) + " the Net of earnings would be " + _vm._s(_vm.currencyFormat(_vm.totalNetIncome * _vm.dateDiff())) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bae374e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/earnings.vue
// module id = 1710
// module chunks = 0